import FeaturePage from "../../components/FeaturePage";
import { Smartphone, Wallet, Sparkles, Globe, Receipt, Heart } from "lucide-react";

export default function Solopreneurs() {
  return (
    <FeaturePage
      badge="For Solopreneurs"
      title="Just you. But fully equipped."
      highlight=""
      subtitle="When you're running everything alone, you don't need more software — you need software that just works. Brivo gives you a storefront, payments, inventory, and analytics in one app."
      heroImage="https://images.unsplash.com/photo-1769636930047-4478f12cf430?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="pink"
      features={[
        { icon: <Smartphone size={22} />, title: "Run from your phone", desc: "The Brivo app does everything the desktop does, in your pocket." },
        { icon: <Wallet size={22} />, title: "Get paid fast", desc: "Same-day payouts so cashflow doesn't bottleneck your hustle." },
        { icon: <Sparkles size={22} />, title: "Beautiful storefront", desc: "Look like a brand on day one with designer templates." },
        { icon: <Globe size={22} />, title: "Sell worldwide", desc: "Multi-currency checkout & global shipping handled for you." },
        { icon: <Receipt size={22} />, title: "Auto-records", desc: "Every sale, expense, and tax line logged automatically." },
        { icon: <Heart size={22} />, title: "Customer love", desc: "Loyalty rewards and email marketing baked in." },
      ]}
      details={[
        {
          tag: "Solo, not alone",
          title: "Like having a co-founder.",
          desc: "Brivo handles the operational chaos so you can focus on the craft. From inventory tracking to invoice chasing — we've got it.",
          bullets: ["Run sales from your phone", "Auto-reconcile payments", "Smart restock reminders"],
        },
        {
          tag: "Affordable",
          title: "Free to start. Made to grow.",
          desc: "Launch on the free plan. Upgrade only when you outgrow it. No hidden fees, no transaction surcharges, no surprises.",
        },
      ]}
      useCases={[
        { title: "Etsy creators", desc: "Move from listings to your own brand." },
        { title: "Instagram sellers", desc: "Take DM orders and turn them into a store." },
        { title: "Pop-up vendors", desc: "Run a market stall today, an empire tomorrow." },
        { title: "Consultants", desc: "Invoice, get paid, deliver, repeat." },
      ]}
      ctaTitle="Solo. Not small."
      ctaSubtitle="Build a brand that punches above its weight. Brivo gives you the tools."
      ctaAccent="cream"
    />
  );
}
